export default {
  business: state => state.business,
  businesses: state => state.businesses,
  totalBusinesses: state => state.totalBusinesses,
  searchTerm: state => state.searchTerm,
  pageSize: state => state.pageSize,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  status: state => state.status,
  filterBy: state => state.filterBy,
  businessContacts: state => state.businessContacts
}



// WEBPACK FOOTER //
// ./src/store/modules/businesses/getters.js